import { apiClient, assertOk } from "@/api/generated/client.ts"

import type { KPIValueUpdateRequest } from "../types/kpiEditorTypes.ts"

export const upsertKPIValue = async (req: KPIValueUpdateRequest, id?: number) => {
  const requests = [req]

  if (id != undefined) {
    const { error, response } = await apiClient.PUT("/api/KPIs/{kpiId}/values/{valueId}", {
      params: { path: { kpiId: req.kpiId, valueId: id } },
      body: req,
    })
    assertOk(response, error)
  } else {
    const { error, response } = await apiClient.POST("/api/KPIs/{kpiId}/values", {
      params: { path: { kpiId: req.kpiId } },
      body: requests,
    })
    assertOk(response, error)
  }
}
